import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import ErrorsToast from '@/components/toasts/ErrorsToast';
import UpdatedToast from '@/components/toasts/UpdatedToast';
import DeletesToast from '@/components/toasts/DeletesToast';
import { responseError } from '@/utils/errors';
import ErrorToast from '@/components/toasts/ErrorToast';
import actions from '../constants';
import DatasetCreatedToast from '../components/DatasetCreatedToast';
import DictionaryConvertToastError from '../data/components/DictionaryConvertToastError';
import DictionaryConvertToast from '../data/components/DictionaryConvertToast';

export function* updateDatasetSettingsToast({ code, name, silent }) {
  if (!silent) {
    yield call(showToast, <UpdatedToast code={code} name={name} />);
  }
}

export function* updateDatasetToast({ code, result }) {
  yield call(showToast, <UpdatedToast code={code} name={result.catalogue.title} />);
}

export function* newDatasetToast({ result, silent }) {
  if (!silent) {
    yield call(showToast, <DatasetCreatedToast code={result.code} name={result.catalogue.title} />);
  }
}

export function* destroyDatasetToast({ items, silent }) {
  if (!silent) {
    yield call(showToast, <DeletesToast items={items} />);
  }
}

export function* destroyDatasetErrorToast({ items }) {
  const errors = items.map((item) => ({ ...item, name: item.catalogue.title }));
  yield call(showToast, <ErrorsToast operation="actions.delete" errors={errors} />);
}

export function* convertDictionaryToast({ dictionaryName, isNew }) {
  yield call(showToast, <DictionaryConvertToast dictionaryName={dictionaryName} isNew={isNew} />);
}

export function* convertDictionaryErrorToast({ dictionaryName, isNew }) {
  yield call(showToast, <DictionaryConvertToastError dictionaryName={dictionaryName} isNew={isNew} />);
}

export function* downloadDatasetErrorToast(action) {
  const error = responseError(action).message;
  yield call(showToast, <ErrorToast operation="actions.download" name={action.code} error={error} />);
}

export default function* datasetsToasts() {
  yield takeEvery(actions.DATASET_SETTINGS_CHANGED, updateDatasetSettingsToast);
  yield takeEvery([actions.UPDATE_DATASET_SUCCESS, actions.UPDATE_DATASET_CATALOGUE_SUCCESS], updateDatasetToast);
  yield takeEvery(actions.NEW_DATASET, newDatasetToast);
  yield takeEvery(actions.DESTROY_DATASET, destroyDatasetToast);
  yield takeEvery(actions.DESTROY_DATASET_ERROR, destroyDatasetErrorToast);
  yield takeEvery(actions.CONVERT_TO_DICTIONARY_SUCCESS, convertDictionaryToast);
  yield takeEvery(actions.CONVERT_TO_DICTIONARY_ERROR, convertDictionaryErrorToast);
  yield takeEvery(actions.DOWNLOAD_DATASET_ERROR, downloadDatasetErrorToast);
}
